module.exports = __webpack_public_path__ + "static/media/history-solid.b1faa8d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/history-solid.svg
// module id = 419
// module chunks = 0